﻿export function InitOrderShowMore() {
    const cards = document.querySelectorAll('.order-more-info');

    cards.forEach(card => {
        const button = card.querySelector('.btn-show-more');

        if (button) {
            button.addEventListener('click', () => {
                card.classList.toggle('show');

                setTimeout(() => {
                    card.classList.toggle('fully-expanded');
                }, 10); // Adjust the delay as needed

                const spans = button.querySelectorAll('span');
                spans.forEach(span => {
                    span.classList.toggle('d-none');
                });
            });
        }
    });
}